(() => {
  const container = document.getElementById('ProductGridContainer');

  if (!container) return;

  const titleSelector =
    '.product-card-wrapper > .card > .card__content > .card__information > .card__heading';
  let animationFrame;

  const alignProductCardTitleRows = () => {
    const grid = container.querySelector('#product-grid');

    if (!grid) return;

    const titles = Array.from(grid.querySelectorAll(titleSelector));
    const rows = new Map();

    titles.forEach((title) => {
      title.style.removeProperty('--product-card-title-row-height');
      title.removeAttribute('data-product-title-lines');
    });

    titles.forEach((title) => {
      const gridItem = title.closest('.grid__item');

      if (!gridItem) return;

      const rowTop = Math.round(gridItem.offsetTop);
      const row = rows.get(rowTop) || [];
      row.push(title);
      rows.set(rowTop, row);
    });

    rows.forEach((rowTitles) => {
      const rowHeight = Math.ceil(
        Math.max(...rowTitles.map((title) => title.getBoundingClientRect().height))
      );

      rowTitles.forEach((title) => {
        const lineHeight = Number.parseFloat(getComputedStyle(title).lineHeight);
        const lineCount = lineHeight ? Math.min(2, Math.max(1, Math.round(rowHeight / lineHeight))) : 1;

        title.style.setProperty('--product-card-title-row-height', `${rowHeight}px`);
        title.dataset.productTitleLines = String(lineCount);
      });
    });
  };

  const scheduleAlignment = () => {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(alignProductCardTitleRows);
  };

  new MutationObserver(scheduleAlignment).observe(container, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('resize', scheduleAlignment, { passive: true });
  window.addEventListener('pageshow', scheduleAlignment);
  document.addEventListener('shopify:section:load', scheduleAlignment);

  if (document.fonts?.ready) document.fonts.ready.then(scheduleAlignment);

  scheduleAlignment();
})();
